import { BADGE_LIST } from "@badgesaction";

export function badgeList(state = {}, action) {
  if (action.type === BADGE_LIST) {
    return action.payload;
  }
  return state;
}
